<template>
  <div class="row h-100 no-gutters">
    <div class="auth-form mx-auto my-auto col-md-5 col-lg-3">
      <div class="card">
        <div class="card-body">
          <h1 style="text-align: center">
            <img
              id="main-logo"
              class="d-inline-block align-top mr-1"
              style="max-width: 100px;"
              src="@/assets/images/logo.png"
              alt="PetFish - logo" />
          </h1>
          <d-alert
            v-if="authError"
            theme="danger"
            show>
            Invalid credentials. Please try again.
          </d-alert>
          <form @submit="login">
            <div class="form-group">
              <label>
                <span>E-mail address:</span>
              </label>
              <d-input
                v-model="email"
                name="email"
                type="email"
                @input="clearError('email')"
                :class="{'is-invalid' : larErrors.has('email')}"
                placeholder="E-mail address" />
              <div class="invalid-feedback" v-text="larErrors.get('email')"></div>
            </div>
            <div class="form-group">
              <label class="d-flex align-middle">
                <span>Password:</span>
                <small class="forget-link ml-auto">
                  <router-link to="/password-reset" :tabindex="-1">
                    forget password?
                  </router-link>
                </small>
              </label>
              <d-input
                v-model="password"
                name="password"
                type="password"
                autocomplete="off"
                @input="clearError('password')"
                :class="{'is-invalid' : larErrors.has('password')}"
                placeholder="********" />
              <div class="invalid-feedback" v-text="larErrors.get('password')"></div>
            </div>
            <button
              type="submit"
              class="btn btn-pill btn-accent d-table mx-auto"
              @click.prevent="login"
              :disabled="submitting">
              <template v-if="!submitting">Log in</template>
              <template v-else>Logging in&hellip;</template>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LarErrors from '../utils/Errors';

export default {
  name: 'Login',
  components: {
    LarErrors
  },
  data () {
    return {
      authError: false,
      submitting: false,
      larErrors: LarErrors,
      email: '',
      password: '',
    }
  },
  methods: {
    clearError () {
      this.authError = false;
    },
    login () {
      this.clearError();
      this.submitting = true;
      this.$http.post('/auth/login', {
        email: this.email,
        password: this.password
      }).then((response) => {
        this.submitting = false;

        if (response.data.google2fa_enabled) {
          this.$router.push('/2fa/' + response.data.token);
        } else {
          window.localStorage.setItem('token', response.data.access_token);
          window.localStorage.setItem('last-token-refresh', +new Date());
          this.$root.userLoggedIn = true;
          this.$http.defaults.headers['Authorization'] = `Bearer ${response.data.access_token}`;
          this.$nextTick(() => {
            if (response.data.must_change_password) {
              this.$router.push('/dashboard/change-password/force');
              return;
            }

            let potentialRedirect = window.crmGetRedirect();

            if (potentialRedirect) {
              this.$router.push(potentialRedirect);
            } else {
              this.$router.push('/dashboard');
            }
          });
        }
      }).catch((error) => {
        console.log(error);
        this.submitting = false;
        this.authError = true;
      });
    }
  }
}
</script>

<style scoped scss>
label {
  align-items: flex-end;
  display: block;

  & > span {
    display: inline-block;
  }
}

.forget-link {
  display: inline-block;
}
</style>
